import { updateLinksAttributes } from '../../utils/handleAttributes';
import { missingWidget } from '../../utils/helpers';

export default function seoWidget() {
  const widgetName = 'seoWidget';
  const $widget = $(`#${widgetName}`);
  const widgetOpts = typeof seoWidgetOpts === 'undefined' ? null : seoWidgetOpts;

  if (!widgetOpts) {
    missingWidget(widgetName);
    return;
  }

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    textOverImage: false,
    itemsPerPanel: 1,
    maxItemsVisible: 1,

    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomSeo(data.items, $widget);
      } else {
        $widget.remove();
      }
    },
  });
}

function createCustomSeo(widgetData, $widget) {
  const $seo = $widget.find('.card-widget-item');
  const { Title, Description, URL } = widgetData[0];

  $seo.replaceWith(`
    <div class="text-section">
      <h1 class="seo-title">${Title}</h1>
      <div class="seo-description">${Description}</div>
    </div>   
  `);

  const firstHeadline = $widget.find('.seo-title span:nth-child(1)').text();
  const secondHeadline = $widget.find('.seo-title span:nth-child(2)').text();

  $widget.find('.seo-title').attr('aria-label', (firstHeadline + ' ' + secondHeadline).trim());

  if (URL == null || URL === '') {
    return;
  }

  const linkAriaLabel = `Learn more about ${secondHeadline}`;
  const linkAttributes = updateLinksAttributes(URL, linkAriaLabel);

  $widget
    .find('.text-section')
    .append(`<a href="${URL}" class="button invert-color" ${linkAttributes}>Learn More</a>`);
}
